export const currentApexLocale = 
    [{
        name: 'ptBR',
        options : {
            months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            shortDays: ['Dom', 'Seg', 'Tre', 'Qua', 'Qui', 'Sex', 'Sáb'],
            toolbar: {
                download: 'Baixar SVG',
                selection: 'Seleção',
                selectionZoom: 'Seleção de Zoom',
                zoomIn: 'Mais zoom',
                zoomOut: 'Menos zoom',
                pan: 'Panorâmico',
                reset: 'Reiniciar zoom',
            }
        }
    }]
